@if(isLoading) {
<app-loading-indicator />
} @else { @if (!isExpanded) {
<div
  class="container"
  [style]="{
    border: '2px solid #e1e8fb',
    'border-radius': '10px',
    padding: '5px',
    marginTop: '5px'
  }"
  [ngClass]="{'playlist-selected': isPlaylistSelected()}"
>
  <div *ngIf="isSharedFromOtherMode()" class="shared-mode-notice"><i class="pi pi-lock me-2" aria-hidden="true"></i><strong>Read-only here.</strong> Edit in {{ academyModeService.getModeDisplayNameById(playlist!.SparkModeID!) }}.</div>
  <div class="row h-4rem align-items-center justify-content-between" [class]="isSelecting ? 'cursor-pointer' : ''" (click)="isSelecting ? toggleCollapsed() : null">
    <div class="col-3 d-flex align-items-center">
      <button
        type="button"
        class="btn btn-primary position-relative program-name"
        (click)="!isSelecting ? toggleCollapsed() : null"
        [id]="'toggleCollapseButton-' + playlist?.PlaylistName"
      >
        {{ playlistNameDisplayName }} <span *ngIf="isSharedFromOtherMode()" class="shared-mode-title">(shared from {{ academyModeService.getModeDisplayNameById(playlist!.SparkModeID!) }})</span>
      </button>
    </div>
    @if (playlist?.IsDeleted) {
    <div class="col-1">
      <p-tag id="deleted-tag" severity="danger" value="Deleted" class="ms-2" />
    </div>
    }

    <div class="col-6 mx-3 mt-2 mt-md-0">
      <span class="fw-bolder" style="color: #719eb6">
        Included programs/targets:
      </span>
      <span style="color: #719eb6">
        {{ playlistItemsNames }}
      </span>
    </div>

    <div class="col-1">
      @if(orderMode === 'custom' && isEditMode) {
      } @else {
        <i
          class="pi pi-arrow-down pointer"
          style="font-size: 1rem; color: #719eb6"
          (click)="!isSelecting ? toggleCollapsed() : null"
        ></i>
      }
    </div>
  </div>
</div>
} @else {
<div
  class="container"
  [style]="{
    border: '2px solid #719eb6',
    'border-radius': '10px',
    padding: '5px',
    marginTop: '5px'
  }"
  id="uncollapsedPlaylist"
>
  <div *ngIf="isSharedFromOtherMode()" class="shared-mode-notice"><i class="pi pi-lock me-2" aria-hidden="true"></i><strong>Read-only here.</strong> Edit in {{ academyModeService.getModeDisplayNameById(playlist!.SparkModeID!) }}.</div>
  <div class="row h-4rem align-items-center justify-content-between">
    <div class="col-md-4 col-sm-12">
      <div class="d-flex align-items-center">
        <button
          type="button"
          class="btn btn-primary position-relative program-name"
          (click)="toggleCollapsed()"
          [id]="'toggleCollapseButton-' + playlist?.PlaylistName"
        >
          {{ playlistNameDisplayName }} <span *ngIf="isSharedFromOtherMode()" class="shared-mode-title">(shared from {{ academyModeService.getModeDisplayNameById(playlist!.SparkModeID!) }})</span>
        </button>
        @if (playlist?.IsDeleted) {
        <p-tag
          id="deleted-tag"
          severity="danger"
          value="Deleted"
          class="ms-2"
        />
        }
      </div>
    </div>
    <div class="col-auto">
      <i
        class="pi pi-arrow-up pointer"
        (click)="toggleCollapsed()"
        style="font-size: 1rem; color: #719eb6"
      ></i>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div
        class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
      >
        <span class="fw-bold" style="color: #719eb6">Playlist Name:</span>
        <span class="text-truncate" style="color: #719eb6">
          {{ playlistNameDisplayName }} <span *ngIf="isSharedFromOtherMode()" class="shared-mode-title">(shared from {{ academyModeService.getModeDisplayNameById(playlist!.SparkModeID!) }})</span>
        </span>
      </div>
    </div>
  </div>

  <div class="row" id="playlistItemsList">
    <div class="col-12">
      <div
        class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
      >
        <span class="fw-bold" style="color: #719eb6"
          >Included programs/targets:</span
        >
      </div>

      <div class="row">
        @for (item of orderedItems(); track item.OrderNr) { @if
        (item.PatientProgramID) {
        <app-program
          [patientID]="patientID()"
          [program]="programForID(item.PatientProgramID)"
          [isExpanded]="programExpandedStatus[item.PatientProgramID]"
          (isExpandedChange)="onProgramExpandedChange(item.PatientProgramID, $event)"
          [targetExpandedStatus]="targetExpandedStatus"
          (targetExpandedChange)="onTargetExpandedChange($event.targetId, $event.isExpanded)"
        />
        } @else {
        <app-target
          [patientID]="patientID()"
          [target]="targetForID(item.PatientTargetID!)"
          [isExpanded]="targetExpandedStatus[item.PatientTargetID!]"
          (isExpandedChange)="onTargetExpandedChange(item.PatientTargetID!, $event)"
        />
        } } @empty {
        <p>There are no programs/targets for this playlist yet.</p>
        }
      </div>
    </div>
  </div>

  <p *ngIf="isSharedFromOtherMode()" class="shared-mode-notice m-3">Read-only here. Edit in {{ academyModeService.getModeDisplayNameById(playlist!.SparkModeID!) }}.</p>
  <div class="row" id="playlistActions" *ngIf="!isSharedFromOtherMode()">
    <div class="col-12">
      <div
        class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
      >
        <button
          (click)="editPlaylist()"
          [id]="'editPlaylistButton-' + playlist?.PlaylistName"
          class="side-menu-button2 flex-grow-1 mx-2"
          [disabled]="playlist?.IsDeleted"
          [style.opacity]="playlist?.IsDeleted ? '0.5' : '1'"
          [style.cursor]="playlist?.IsDeleted ? 'not-allowed' : 'pointer'"
        >
          Edit
        </button>
        
    @if (!playlist?.IsDeleted) {
        <button
          (click)="deletePlaylist()"
          [id]="'deletePlaylistButton-' + playlist?.PlaylistName"
          class="switch-mode-button flex-grow-1 mx-2"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
        >
          Delete
        </button>
      }
      @else {
        <button
          (click)="restorePlaylist()"
          [id]="'restorePlaylistButton-' + playlist?.PlaylistName"
          class="switch-mode-button flex-grow-1 mx-2"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
        >
          Restore
        </button>
      }
      </div>
    </div>
  </div>
</div>

} }
